import { render, staticRenderFns } from "./SubscriptionManagement.vue?vue&type=template&id=5c5ca372"
import script from "./SubscriptionManagement.vue?vue&type=script&lang=js"
export * from "./SubscriptionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports